import { SpecialPriceType } from '../App.types'

export const venueHasCorporatePrice = (venueSpecialPrices: Array<SpecialPriceType>) => {
  return Boolean(venueSpecialPrices.includes(SpecialPriceType.CORPORATE_EMPLOYEES))
}
